import { toDate as e } from "./toDate.js";
function n(t) {
  const r = e(t);
  return Math.trunc(r.getMonth() / 3) + 1;
}
export {
  n as default,
  n as getQuarter
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getQuarter.js
// module id = 1390
// module chunks = 67